/**
 * Extracts all <a>...</a> elements from an HTML string.
 * @param html The HTML string.
 * @returns Array containing the HTML strings of the <a> elements.
 */
export function extractAnchorTags(html: string): string[] {
    const anchorTags: string[] = [];
    const regex = /<a\b[^>]*>(.*?)<\/a>/gi;
    let match: RegExpExecArray | null;
    while ((match = regex.exec(html)) !== null) {
        anchorTags.push(match[0]);
    }
    return anchorTags;
}
